import { getTicketTypeById } from '../../../sales-data/selectors/tickets/get-ticket-type-by-id';
import { getTicketTypeTicketCount } from '../../../sales-data/utils/tickets/ticket-type-utils';
import { getOrderTicketsForShowtime } from './get-order-tickets-for-showtime';
export const getOrderTicketCountPerAreaCategory = (showtimeId) => {
    return getOrderTicketsForShowtime(showtimeId).reduce((acc, ticket) => {
        const ticketType = getTicketTypeById(ticket.ticketTypeId);
        const { areaCategoryId } = ticketType;
        const previousCount = acc.get(areaCategoryId) || 0;
        const ticketCount = getTicketTypeTicketCount(ticketType);
        return acc.set(areaCategoryId, previousCount + ticketCount);
    }, new Map());
};
